import {ImUsers, ImPieChart}        from "react-icons/im";
import {MdLocalGasStation}                       from "react-icons/md";
import {FaTruck, FaFileInvoiceDollar, FaPercent} from "react-icons/fa";
import {FaTrashAlt, FaMapMarkerAlt, FaSearch}    from "react-icons/fa";
import {FaFileContract}                          from "react-icons/fa";
import {BiTransfer, BiSupport}                   from "react-icons/bi";
import {MdHistory, MdNotifications, MdStackedLineChart} from "react-icons/md";
import {GiCoffeeCup}                             from "react-icons/gi";
import {RiBankCardFill}                          from "react-icons/ri";
import {SecurityScanOutlined}                    from "@ant-design/icons";

import lookups                                from "./lookups.json";
const pages = lookups.obj.fuel_user.branch;

const pagesList = [
    {
        id: pages.help_center,
        url: `/${pages.help_center}/:id?/:tab?/`,
        icon: BiSupport,
    },
    {
        id: pages.alert,
        url: `/${pages.alert}/:id?/:tab?`,
        icon: MdNotifications,
    },
    {
        id: pages.administrator_company,
        url: `/${pages.administrator_company}/:id?/:tab?/:sub_id?/:sub_tab?/:more?`,
        icon: GiCoffeeCup,
    },
    {
        id: pages.gas_station_company,
        url: `/${pages.gas_station_company}/:id?/:tab?/:sub_id?/:sub_tab?/:more?`,
        icon: MdLocalGasStation,
    },
    {
        id: pages.carrier_company,
        url: `/${pages.carrier_company}/:id?/:tab?/:sub_id?/:sub_tab?/:more?`,
        icon: FaTruck,
    },
    {
        id: pages.transaction,
        url: `/${pages.transaction}/:id?/:tab?/:sub_id?/:sub_tab?/:more?`,
        icon: BiTransfer,
    },
    {
        id: pages.invoice,
        url: `/${pages.invoice}/:id?/:tab?`,
        icon: FaFileInvoiceDollar,
    },
    {
        id: pages.bank_transfer,
        url: `/${pages.bank_transfer}/:id?/:tab?`,
        icon: RiBankCardFill,
    },
    {
        id: pages.administration,
        url: `/${pages.administration}/:id?/:tab?/:sub_id?/:sub_tab?/:more?`,
        icon: ImUsers,
    },
    {
        id: pages.securityGroup,
        url: `/${pages.securityGroup}`,
        icon: SecurityScanOutlined,
    },
    {
        id: pages.contract,
        url: `/${pages.contract}/:id?/:tab?`,
        icon: FaFileContract,
    },
    {
        id: pages.discount,
        url: `/${pages.discount}/:id?/:tab?`,
        icon: FaPercent,
    },
    {
        id: pages.price_analysis,
        url: `/${pages.price_analysis}`,
        icon: MdStackedLineChart,
    },
    {
        id: pages.statistic,
        url: `/${pages.statistic}/:tab?`,
        icon: ImPieChart,
    },
    {
        id: pages.search,
        url: `/${pages.search}/:tab?/:id?/:sub_tab?`,
        icon: FaSearch,
    },
    {
        id: pages.tracker,
        url: `/${pages.tracker}`,
        icon: FaMapMarkerAlt,
    },
    {
        id: pages.history,
        url: `/${pages.history}`,
        icon: MdHistory,
    },
    {
        id: pages.basket,
        url: `/${pages.basket}`,
        icon: FaTrashAlt,
    },
]

export default pagesList;
